import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const createMaintenanceSchedule = createAsyncThunk("maintenanceSchedule/createMaintenanceSchedule", async (data, { rejectWithValue }) => {
  try {
    const res = await useInsertData("maintenanceSchedules", data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getAllMaintenanceSchedule = createAsyncThunk("maintenanceSchedule/getAllMaintenanceSchedule", async (page = 1, { rejectWithValue }) => {
  try {
    const res = await useGetData("maintenanceSchedules?page=" + page);
    return res;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getAllMaintenanceScheduleById = createAsyncThunk("maintenanceSchedule/getAllMaintenanceScheduleById", async (id, { rejectWithValue }) => {
  try {
    const res = await useGetData(`maintenanceSchedules/${id}`);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const assignTechnician = createAsyncThunk("maintenanceSchedule/assignTechnician", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`maintenanceSchedules/assignTechnician/${id}`, data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const assignMangerAndStuffContract = createAsyncThunk("contracts/assignMangerAndStuff", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`maintenanceSchedules/assign-schedules/${id}`, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
export const assignMangerAndStuffSingleShedule = createAsyncThunk("contracts/assignMangerAndStuffSingleShedule", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`maintenanceSchedules/assign/${id}`, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
export const updateMaintenanceSchedule = createAsyncThunk("maintenanceSchedule/updateSchedule", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`maintenanceSchedules/${id}`, data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getAllMyTasks = createAsyncThunk("maintenanceSchedule/getAllMyTasks", async (page = 1, { rejectWithValue }) => {
  try {
    const res = await useGetData(`maintenanceSchedules/assignedSchedules?page=` + page);
    console.log(res);
    return res;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const deleteMainTenanceSchedule = createAsyncThunk("maintenanceSchedule/deleteMainTenanceSchedule", async (id, { rejectWithValue }) => {
  try {
    const res = await useDeleteData(`maintenanceSchedules/force/${id}`);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

const initialState = {
  maintenanceSchedule: null,
  allMaintenanceSchedule: null,
  specificMaintenanceSchedule: null,
  allMyTasks: null,
  status: "idle",
  error: null,
  token: null,
};
export const maintenanceScheduleSlice = createSlice({
  name: "MaintenanceSchedule",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(createMaintenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createMaintenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.maintenanceSchedule = action.payload;
      })
      .addCase(createMaintenanceSchedule.rejected, (state, action) => {
        state.status = "failed";

        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllMaintenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllMaintenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allMaintenanceSchedule = action.payload;
      })
      .addCase(getAllMaintenanceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllMaintenanceScheduleById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllMaintenanceScheduleById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.specificMaintenanceSchedule = action.payload;
      })
      .addCase(getAllMaintenanceScheduleById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(assignTechnician.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(assignTechnician.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(assignTechnician.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllMyTasks.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllMyTasks.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allMyTasks = action.payload;
      })
      .addCase(getAllMyTasks.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateMaintenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateMaintenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateMaintenanceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteMainTenanceSchedule.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteMainTenanceSchedule.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(action.payload);
        // state.maintenanceSchedule = state.maintenanceSchedule.filter((item) => item == action.payload);
      })
      .addCase(deleteMainTenanceSchedule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
    // //---------------------------------------
    // .addCase(resendCode.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resendCode.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resendCodeResponse = action.payload;
    // })
    // .addCase(resendCode.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(loginUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(loginUser.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.currentUser = action.payload.data;
    //   state.token = action.payload.token;
    // })
    // .addCase(loginUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(getCurrentUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(getCurrentUser.fulfilled, (state, action) => {
    //   state.currentUser = action.payload.user;
    //   state.status = "succeeded";
    // })
    // .addCase(getCurrentUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(forgetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(forgetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.forgetPasswordResponse = action.payload;
    // })
    // .addCase(forgetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(resetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resetPasswordResponse = action.payload;
    // })
    // .addCase(resetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(updateUserData.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(updateUserData.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.user = action.payload;
    // })
    // .addCase(updateUserData.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // });
  },
});
export default maintenanceScheduleSlice.reducer;
